import angular from "angular";

angular
    .module('mobiusControl.mobiusRequestLog', [])
    .service('MobiusRequestLog', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/mobius/request-logs';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.getItem = function (id) {
            return $http.get(uri(id));
        };

    }]);

export default "mobiusControl.mobiusRequestLog"


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-request-log.js